<template>
  <div
    @click="estadoAtual !== estadosComputed.CARREGANDO ? $emit('baixar') : ''"
    class="container-circular"
    :class="{ selecionado: estadoAtual === estadosComputed.CARREGANDO }"
  >
    <transition name="fade-icone" mode="out-in">
      <unicom-icone
        v-if="estadoAtual === estadosComputed.NORMAL"
        class="icone-circular"
        nome="download-cloud"
        :tamanho="14"
      />
      <div v-else-if="estadoAtual === estadosComputed.CARREGANDO">
        <LoadingCircular
          class="loading-circular"
          :radius="14"
          :progress="loading"
          :stroke="1"
        />
        <unicom-icone
          class="icone-circular"
          nome="download-cloud"
          :tamanho="14"
        />
      </div>
      <div v-else>
        <unicom-icone class="icone-circular" nome="check" :tamanho="14" />
      </div>
    </transition>
  </div>
</template>

<script>
import LoadingCircular from "./LoadingCircular";

const ESTADOS = {
  NORMAL: "NORMAL",
  CARREGANDO: "CARREGANDO",
  COMPLETO: "COMPLETO"
};

export default {
  components: {
    LoadingCircular
  },
  props: {
    loading: {
      type: Number,
      default: -1
    }
  },
  computed: {
    estadosComputed() {
      return ESTADOS;
    },
    estadoAtual() {
      if (this.loading === -1) return this.estadosComputed.NORMAL;
      return this.loading === 101
        ? this.estadosComputed.COMPLETO
        : this.estadosComputed.CARREGANDO;
    }
  }
};
</script>

<style lang="scss" scoped>
.container-circular {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: #1daa7d;
  color: white;
  cursor: pointer;
  position: relative;

  .icone-circular {
    padding: 5px;
  }

  .loading-circular {
    position: absolute;
    top: -2px;
    left: -2.11px;
  }

  &.selecionado {
    background: white;
    color: #1daa7d;
  }
}
</style>
